import {createSlice} from "@reduxjs/toolkit";

const initialGalleryImagesState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: null,
  galleryImageForEdit: undefined,
  lastError: null
};
export const callTypes = {
  list: "list",
  action: "action"
};

export const galleryImagesSlice = createSlice({
  name: "galleryImages",
  initialState: initialGalleryImagesState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getGalleryImageById
    galleryImageFetched: (state, action) => {
      state.actionsLoading = false;
      state.galleryImageForEdit = action.payload.galleryImageForEdit;
      state.error = null;
    },
    // findGalleryImages
    galleryImagesFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    // createGalleryImage
    galleryImageCreated: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.entities.push(action.payload.galleryImage);
    },
    // updateGalleryImage
    galleryImageUpdated: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.map(entity => {
        if (entity.galleryImageId === action.payload.galleryImage.galleryImageId) {
          return action.payload.galleryImage;
        }
        return entity;
      });
    },
    // deleteGalleryImage
    galleryImageDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(el => el.galleryImageId !== action.payload.galleryImageId);
    },
    // deleteGalleryImages
    galleryImagesDeleted: (state, action) => {
      state.error = null;
      state.actionsLoading = false;
      state.entities = state.entities.filter(
        el => !action.payload.ids.includes(el.galleryImageId)
      );
    },
  }
});
